"use client";
import { ospThemes } from "../ospThemes";
// import dynamic from "next/dynamic";
// import type { LottieComponentProps } from "lottie-react";
import { UiSvgs, UiSvgsPropsType } from "../svgs";
import { useStyles } from "./styles";
// import loadingAnimation from "./loading.json";


// const LottieReact = dynamic(() => import('lottie-react'), { ssr: false });

export function Loading(props: Omit<UiSvgsPropsType, "name">) {
	const { styles, cx } = useStyles();
	// loading无限循环 keysframe
	return (
		<UiSvgs
			name="loadingCycle"
			{...props}
			className={cx(styles.loading, props.className)}
		/>
	);
}


export function LoadingLottie(props: Omit<UiSvgsPropsType, "name">) {
    const width = props?.width || props?.size || 80;
    const height = props?.height || props?.size || 80;
	return <Loading
		fill={ospThemes.colors.content_tertiary}
		{...props}
		style={{
			width,
			height,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			...props.style,
		}}
	/>
}